import { render, staticRenderFns } from "./joiner_index.vue?vue&type=template&id=c597b8e6&scoped=true&"
import script from "./joiner_index.vue?vue&type=script&lang=js&"
export * from "./joiner_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c597b8e6",
  null
  
)

export default component.exports